// extracted by mini-css-extract-plugin
module.exports = {"modal":"VideoModal_modal__npHkp","closeButton":"VideoModal_closeButton__jUSDp","overlay":"VideoModal_overlay__IOEP0"};